// Bullseye / target — used on the bolão tile to denote the coverage multiplier.
const TargetIcon: React.FC<{ size?: string; color?: string }> = ({
  size = "14",
  color = "currentColor",
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="7" cy="7" r="6" stroke={color} strokeWidth="1.4" />
      <circle cx="7" cy="7" r="3.3" stroke={color} strokeWidth="1.4" />
      <circle cx="7" cy="7" r="1.3" fill={color} />
    </svg>
  );
};
export default TargetIcon;
